import React from 'react';
import { Table, message, Tabs } from 'antd';
import dayjs from 'dayjs';

export default () => {
    const [ dataSource, setDataSource ] = React.useState([]);

    const getDraftList = async () => {
        const response = await fetch('/api/sys/mini-draft-list');
        const result = await response.json();

        if(result?.success) {
            return result?.data?.draft_list;
        }
    };

    React.useEffect(() => {
        getDraftList().then(data => {
            if(data) setDataSource(data);
        });
    }, []);

    const columns = [
        {
            title: '版本',
            dataIndex: 'user_version',
        },
        {
            title: '创建时间',
            dataIndex: 'create_time',
            render: (text) => <div>{dayjs(text * 1000).format('YYYY-MM-DD HH:mm:ss')}</div>,
        },
        {
            title: '开发者',
            dataIndex: 'developer',
        },
        {
            title: '操作',
            dataIndex: 'action',
            render: (text, record) => {
                return (
                    <a onClick={() => addToTemplate(record.draft_id)}>添加到模板</a>
                );
            },
        },
    ];

    const addToTemplate = async (draftId) => {
        const response = await fetch(`/api/sys/add-draft-to-template?draftId=${draftId}`);
        const result = await response.json();

        if (result.success) {
            message.success('添加成功');
        }else  {
            message.error(result.data);
        }
    };


    return (
        <Table rowKey="user_version" columns={columns} dataSource={dataSource} />
    )
}